import { createSlice } from '@reduxjs/toolkit';

import { BOX, CIRCLE, LINE, POLYGON } from 'client/utils/constants/symbolName';

export const drawSlice = createSlice({
    name: 'draw',
    initialState: {
        type: null,
        status: [],
        bufferRadiusMetres: null
    },
    reducers: {
        setDrawType: (state, action) => {
            switch (action.payload) {
                // draw area
                case BOX:
                    return { ...state, type: BOX, bufferRadiusMetres: null };
                // draw custom area
                case POLYGON:
                    return { ...state, type: POLYGON, bufferRadiusMetres: null };
                // linear search
                case LINE:
                    return { ...state, type: LINE, bufferRadiusMetres: null };
                default:
                    return { ...state, type: CIRCLE, bufferRadiusMetres: null };
            }
        },
        setBufferRadiusMetres: (state, action) => {
            return { ...state, bufferRadiusMetres: action?.payload };
        },
        addDrawStatus: (state, action) => {
            const drawStatus = action?.payload;
            const status = [...state.status];
            if (drawStatus && !status.includes(drawStatus)) {
                status.push(drawStatus);
            }
            return { ...state, status };
        },
        removeDrawStatus: (state, action) => {
            const status = [...state.status].filter(drawStatus => drawStatus !== action?.payload);
            return { ...state, status };
        },
        clearDrawStatus: (state, action) => {
            return { ...state, status: [] };
        }
    }
});

export const selectDrawType = state => state.draw.type || BOX;
export const selectDrawStatus = state => state.draw.status;

export const DEFAULT_BUFFER_RADIUS_METRES = 10;

export const selectBufferRadiusMetres = (state) => {
    const bufferRadiusMetres = state?.draw?.bufferRadiusMetres;
    return Number.isFinite(bufferRadiusMetres) ? bufferRadiusMetres : DEFAULT_BUFFER_RADIUS_METRES;
};

// Action creators are generated for each case reducer function
export const { setDrawType, setBufferRadiusMetres, addDrawStatus, removeDrawStatus, clearDrawStatus } = drawSlice.actions;

export default drawSlice.reducer;
